import React, { useEffect, useState } from "react";
import api from "../../../api/axios";

import property_icon from "../../../assets/images/property-icon.png";
import dollar_icon from "../../../assets/images/dollar-icon.png";
import no_smoking_icon from "../../../assets/images/no-smoking-icon.png";
import cleaning_icon from "../../../assets/images/cleaning-icon.png";

const filterBtn = [
  { id: 1, title: "All", status: null },
  { id: 2, title: "Vacant", status: "vacant" },
  { id: 3, title: "Occupied", status: "occupied" },
  { id: 4, title: "Reserved", status: "reserved" },
  { id: 5, title: "Booked", status: "booked" },
  { id: 6, title: "Due Out", status: "due_out" },
  { id: 7, title: "Dirty", status: "dirty" },
];

const RoomView = () => {
  const [rooms, setRooms] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [rateTypes, setRateTypes] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [loading, setLoading] = useState(true);

  const [selectedDate, setSelectedDate] = useState(() =>
    new Date().toISOString().slice(0, 10)
  );

  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    try {
      setLoading(true);
      const [roomsRes, reservationsRes, roomTypesRes, rateTypesRes] =
        await Promise.all([
          api.get("pms/rooms"),
          api.get("pms/reservations"),
          api.get("pms/room-types"),
          api.get("pms/rate-types"),
        ]);

      setRooms(roomsRes.data);
      setReservations(reservationsRes.data);
      setRoomTypes(roomTypesRes.data);
      setRateTypes(rateTypesRes.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // Check reservation match for selected date
  const getReservationForRoom = (roomId) => {
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);

    return reservations.find((r) => {
      if (r.room_id !== roomId) return false;

      const cin = new Date(r.check_in);
      const cout = new Date(r.check_out);

      cin.setHours(0, 0, 0, 0);
      cout.setHours(0, 0, 0, 0);

      return selected >= cin && selected <= cout;
    });
  };

  const finalRooms = rooms
    .map((room) => {
      const reservation = getReservationForRoom(room.id);

      const roomTypeObj = roomTypes.find((rt) => rt.id === room.room_type_id);
      const rateTypeObj = reservation
        ? rateTypes.find((rt) => rt.id === reservation.rate_type_id)
        : null;

      return {
        room_number: room.room_number,
        room_type: room.room_type.name,
        guest_name: reservation ? reservation.guest.name : "",
        add_ons: reservation ? rateTypeObj?.name : room.status,
        reservation_status: reservation ? reservation.status : room.status,
        room,
        reservation,
      };
    })
    .filter((item) => {
      if (!selectedFilter) return true;
      return item.reservation_status === selectedFilter;
    });

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body ">
      {/* page header */}
      <div className="row mb-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room View</h3>
          </div>
        </div>
      </div>

      {/* filters */}
      <div>
        <div className="mb-4 d-flex align-items-center flex-wrap">
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="date-container me-2 mb-2 mb-lg-0"
          />

          <div className="d-flex align-items-center flex-wrap gap-2">
            {filterBtn.map((btn) => (
              <button
                key={btn.id}
                type="button"
                onClick={() => setSelectedFilter(btn.status)}
                className="room-cards-filter-btn"
              >
                {btn.title}
              </button>
            ))}
          </div>
        </div>

        <ul className="row g-2 list-unstyled li_animate row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 row-deck mb-lg-5 mb-4">
          {finalRooms.map((data, index) => (
            <li className="col" key={index}>
              <div className="card room-cards p-3 h-100">
                <div className="room-card-body">
                  <div>
                    <div className="room-card-sub1">
                      <img src={property_icon} alt="" />
                      <div>
                        <span className="room-card-id">{data.room_number}</span>
                        <br />
                        <span className="room-card-type">{data.room_type}</span>
                      </div>
                    </div>

                    <h6 className="room-card-gname mt-2">{data.guest_name}</h6>
                  </div>

                  <div className="room-card-sub2">
                    <img src={dollar_icon} alt="" />
                    <img src={no_smoking_icon} alt="" />
                    <img src={cleaning_icon} alt="" />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-end mt-4">
                  <span className="room-cards-pill rounded-pill">
                    {data.add_ons || "Vacant"}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RoomView;
